// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__U4TI6","main":"index_main__Ce991","collapseContent":"index_collapseContent__Ot86V"};